// The sheet body (shared/_modal) is the scroll container for everything inside
// a drawer / bottom sheet. A step switcher swaps which step is visible but
// leaves that container's offset where the last step left it, so a new step
// opens scrolled — on mobile, tapping the last card of a long list lands you at
// the bottom of the next step. Every step transition has to put it back on top.
export function scrollSheetToTop(root: Element): void {
  const body = root.querySelector<HTMLElement>(".modal-body-container");
  if (body) body.scrollTop = 0;
}
